/* eslint-disable react/prop-types */
import React, {useEffect} from 'react';
import messages from 'utils/messages';

// import {ReactComponent as Logo} from 'assets/svgs/logos/JIDIPI.svg';
import {ReactComponent as Logout} from 'assets/svgs/actions/Logout.svg';
import {ReactComponent as ToogleIcon} from 'assets/svgs/actions/menu-toogle.svg';
import Menu from 'assets/svgs/actions/dots.svg';
import NavigationLink from 'components/NavigationLink';
import {removeFromLocalStorage} from 'utils/localStorage';
import history from 'utils/history';
import {socket} from 'utils/connectSocket';
import {useDispatch} from 'react-redux';
import {updateEdit} from 'actions/postActions';
import {updateCompanyEdit} from '../../actions/companyActions';

const Header = () => {
  const dispatch = useDispatch();
  const checkEditor = () => {
    const editorHeader = document.querySelector('[data-ui-id="header"]');

    if (editorHeader && editorHeader.style.position === 'fixed') {
      editorHeader.style.top = '73px';
      editorHeader.classList.add('moving');
    } else if (editorHeader) {
      editorHeader.style.top = '0px';
      editorHeader.classList.remove('moving');
    }
  };

  useEffect(() => {
    const wraper = document.querySelector('.wrapper');
    wraper.addEventListener('scroll', checkEditor);
    const onUpdateEditing = (details) => {
      if (details.type === 'post') {
        dispatch(updateEdit(details));
      } else if (details.type === 'company') {
        dispatch(updateCompanyEdit(details));
      }
    };
    socket.on('watch', onUpdateEditing);
    return () => {
      wraper.removeEventListener('scroll', checkEditor);
      socket.off('watch', onUpdateEditing);
    };
  }, []);

  return (
    <header className="bg-white">
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <button type="button" className="mob-toogles">
          <ToogleIcon />
        </button>
        <NavigationLink className="navbar-brand" to="/posts">
          {/* <Logo width="100" alt="logo" /> */}
          <img
            src="https://upload.jidipi.com/logo/jidipi-logo.png"
            width="100"
            alt="Jidipi"
          />
        </NavigationLink>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <img src={Menu} width="22" alt="" />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active">
              <a
                className="nav-link"
                href="#test"
                onClick={(e) => {
                  e.preventDefault();
                  removeFromLocalStorage('user');
                  history.push(`/login`);
                }}
              >
                <Logout /> {messages.logout}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
